import BInput from './BInput';
export default BInput;
